import {
  Button,
  CardItemContainer,
  CardItemLitter,
  CardItemWrapper,
  Container,
  EmptyOverlay,
  LoadingContainer,
  MtLayoutTitleWrapper,
  Section,
  SectionTitle,
} from '@presentation/components';
import { Illustration } from '@presentation/components/Illustration';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useCallback } from 'react';
import { FaAngleRight } from 'react-icons/fa';
import { TbListSearch } from 'react-icons/tb';
import * as Styled from './styled';
import type { MtWishlistPageProps } from './types';

export * from './types';

export const MtWishlistPage: FC<MtWishlistPageProps> = (props) => {
  const { items, onLitterListClick, loading = false } = props;
  const { translate } = useTranslation();

  const renderLitterCards = useCallback(() => {
    if (loading) {
      return Array(4)
        .fill(undefined)
        .map((_, index) => (
          <CardItemWrapper key={index}>
            <CardItemLitter
              style={{ height: 327.5 }}
              key={index}
              loading
              breed=""
              price=""
              location=""
            />
          </CardItemWrapper>
        ));
    }

    return items.map((litter, index) => (
      <CardItemWrapper key={index}>
        <CardItemLitter {...litter} />
      </CardItemWrapper>
    ));
  }, [items, loading]);

  return (
    <Container>
      <MtLayoutTitleWrapper>
        <SectionTitle>{translate('mt.buyer.bookmarks.title')}</SectionTitle>
      </MtLayoutTitleWrapper>

      {loading && <LoadingContainer />}

      {!loading && !items?.length && (
        <Section>
          <EmptyOverlay
            icon={<Illustration type="paws" />}
            text={translate('mt.buyer.bookmarks.noFavorite')}
          >
            <Button onClick={onLitterListClick} color="blue" shrink iconLeft={<TbListSearch />}>
              {translate('common.buttons.exploreAds')}
            </Button>
          </EmptyOverlay>
        </Section>
      )}

      {!loading && !!items?.length && (
        <>
          <Styled.ShowLittersWrapper onClick={onLitterListClick}>
            {translate('common.buttons.exploreAds')}
            <FaAngleRight />
          </Styled.ShowLittersWrapper>
          <CardItemContainer>{renderLitterCards()}</CardItemContainer>
        </>
      )}
    </Container>
  );
};
